import { useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { KnowledgeHubCertificateSplashScreen } from '@app/components/KnowledgeHubCertificateSplashScreen'
import {
  KnowledgeHubCourseInviteSplashScreen,
  isNotTargetPage,
} from '@app/components/KnowledgeHubCourseInviteSplashScreen'
import { useProfileKnowledgeHubCertificateSplashScreen } from '@app/hooks/useProfileKnowledgeHubCertificateSplashScreen/useProfileKnowledgeHubCertificateSplashScreen'
import { useProfileKnowledgeHubCourseInviteSplashScreen } from '@app/hooks/useProfileKnowledgeHubCourseInviteSplashScreen/useProfileKnowledgeHubCourseInviteSplashScreen'

const INVITE_ACCEPTED_VALUE = 'invite_accepted'

// Only one Knowledge Hub splash screen should ever be shown at a time. If a
// profile is eligible for both, the course-invite pop-up takes priority over
// the certificate one.
export const KnowledgeHubSplashScreens = () => {
  const location = useLocation()

  // make sure we only show 1 certificate at a time. If the user is eligible for both, the course-invite pop-up takes priority over the certificate one.
  const hasCourseInviteBeenEligible = useRef(false)

  const isInviteJustAccepted =
    new URLSearchParams(location.search).get('success') ===
    INVITE_ACCEPTED_VALUE

  const {
    isKnowledgeHubCourseInviteSplashScreenEnabled,
    isKnowledgeHubCourseInviteSplashScreenLoading,
    insertSubmissionOfKnowledgeHubCourseInviteSplashScreen,
  } = useProfileKnowledgeHubCourseInviteSplashScreen()
  const {
    isKnowledgeHubCertificateSplashScreenEnabled,
    insertSubmissionOfKnowledgeHubCertificateSplashScreen,
  } = useProfileKnowledgeHubCertificateSplashScreen()

  if (isNotTargetPage(location.pathname)) {
    return null
  }

  if (isInviteJustAccepted && isKnowledgeHubCourseInviteSplashScreenLoading) {
    return null
  }

  const isCourseInviteSplashScreenEligible =
    isKnowledgeHubCourseInviteSplashScreenEnabled && isInviteJustAccepted

  if (isCourseInviteSplashScreenEligible) {
    hasCourseInviteBeenEligible.current = true

    return (
      <KnowledgeHubCourseInviteSplashScreen
        onSubmit={insertSubmissionOfKnowledgeHubCourseInviteSplashScreen}
      />
    )
  }

  if (
    isKnowledgeHubCertificateSplashScreenEnabled &&
    !hasCourseInviteBeenEligible.current
  ) {
    return (
      <KnowledgeHubCertificateSplashScreen
        onSubmit={insertSubmissionOfKnowledgeHubCertificateSplashScreen}
      />
    )
  }

  return null
}
